import { bindRoutineToReduxForm, createRoutine } from 'redux-saga-routines';

import { createAction } from 'redux-actions';
import {
  AUTH_CHANGE_PASSWORD,
  AUTH_CLEAN,
  AUTH_FORGOT_PASSWORD,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REMEMBER_ME,
  AUTH_RESET_PASSWORD,
  AUTH_SHOW_CONFIRM_PASSWORD,
  AUTH_SHOW_NEW_PASSWORD,
  AUTH_SHOW_PASSWORD,
  AUTH_VERIFY_SESSION,
} from './types';

export const login = createRoutine(AUTH_LOGIN);
export const logout = createRoutine(AUTH_LOGOUT);
export const forgotPassword = createRoutine(AUTH_FORGOT_PASSWORD);
export const changePassword = createRoutine(AUTH_CHANGE_PASSWORD);
export const resetPassword = createRoutine(AUTH_RESET_PASSWORD);
export const verifySession = createRoutine(AUTH_VERIFY_SESSION);

export const rememberMe = createAction(AUTH_REMEMBER_ME);
export const authClean = createAction(AUTH_CLEAN);

export const showPassword = createAction(AUTH_SHOW_PASSWORD);
export const showNewPassword = createAction(AUTH_SHOW_NEW_PASSWORD);
export const showConfirmPassword = createAction(AUTH_SHOW_CONFIRM_PASSWORD);

export const bindedLogin = bindRoutineToReduxForm(login);
export const bindedForgotPassword = bindRoutineToReduxForm(forgotPassword);
export const bindedResetPassword = bindRoutineToReduxForm(resetPassword);
export const bindedChangePassword = bindRoutineToReduxForm(changePassword);
